import React from 'react';
import { useStateValue } from '../../store/store';
import { __ } from '@wordpress/i18n';

const ImportStatus = () => {
	const [{ importStatus }] = useStateValue();

	return (
		<div className="ist-import-status">
            <div className="ist-status-message-wrap">
                <p>{ importStatus }</p>
            </div>
		</div>
	)

}

export default ImportStatus;
